import { SocketStateInterface } from 'src/store/socket/state';
import {
  onWSClose,
  onWSOpen,
  onWSReconnectError,
  onWSReconnect,
} from 'src/services/connection';

export function SOCKET_ONOPEN(state: SocketStateInterface, event: Event) {
  process.env.DEBUGGING && console.info('SOCKET_ONOPEN', event);

  state.isConnected = true;
  state.reconnectError = false;
  onWSOpen();
}
export function SOCKET_ONCLOSE(state: SocketStateInterface, event: CloseEvent) {
  process.env.DEBUGGING && console.info('SOCKET_ONCLOSE', event);

  state.isConnected = false;
  onWSClose(event);
}
export function SOCKET_ONERROR(state: SocketStateInterface, event: Event) {
  process.env.DEBUGGING && console.info('SOCKET_ONERROR', event);

  state.message = event.toString();
  // onWSError();
}
// default handler called for all methods
export function SOCKET_ONMESSAGE(state: SocketStateInterface, message: string) {
  process.env.DEBUGGING && console.info('SOCKET_ONMESSAGE', { message });

  state.message = message;
}
// mutations for reconnect methods
export function SOCKET_RECONNECT(state: SocketStateInterface, count: number) {
  process.env.DEBUGGING && console.info('SOCKET_RECONNECT', { count });

  state.reconnectError = false;
  onWSReconnect();
}
export function SOCKET_RECONNECT_ERROR(
  state: SocketStateInterface,
  event: Event
) {
  process.env.DEBUGGING && console.info('SOCKET_RECONNECT_ERROR', event);

  state.reconnectError = true;
  onWSReconnectError();
}
